export default {
  OrdersPage: {
    orders: 'Orders',
  },
  OrdersTable: {
    orderNumber: 'Order number',
    orderDate: 'Order date',
    paymentMethod: 'Payment method',
    status: 'Status',
    trackingCode: 'Tracking code',
    searchByOrderNumber: 'Search by order number',
    more: 'More',
    any: 'Any',
    cancelled: 'Cancelled',
    completed: 'Completed',
    failed: 'Failed',
    onhold: 'On hold',
    pending: 'Pending',
    refunded: 'Refunded',
    new: 'New',
    checkoutdraft: 'Checkout draft',
    autodraft: 'Auto draft',
    completed2: 'Completed-2',
    trash: 'Trash',
    processing: 'Processing',
    shipped: 'Shipped',
  },
  BillingDetailsTable: {
    buyerName: 'Buyer name',
    street: 'Street',
    city: 'City',
    zip: 'ZIP',
    contact: 'Contact',
    email: 'Email',
  },
  ShippingDetailsTable: {
    buyerName: 'Buyer name',
    street: 'Street',
    city: 'City',
    zip: 'ZIP',
    contact: 'Contact',
  },
  CustomerDetailsTable: {
    customerName: 'Customer name',
    address: 'Address',
    street: 'Street',
    city: 'City',
    zip: 'ZIP',
    contact: 'Contact',
    email: 'Email',
  },
  OrderInfoTable: {
    orderDate: 'Order date',
    status: 'Status',
    trackingCode: 'Tracking code',
  },
  OrderIdInput: {
    orderDoesNotExist: 'Order does not exist',
  },
};
